<p1-lib-ui-elements-image-tile [name]="name"
                               [link]="['/categories/' + pathedSlugs]"
                               [gtmEventCategory]="'Categorytree'"
                               [gtmEventAction]="'Click Category - Name ' + (name | stripNl)"
                               [gtmEventLabel]="'CategorytreeTile'"
                               [ad]="advertising"
                               [imageUuid]="imageUuid">
  <ng-container content>
    <ul *ngIf="childCategories && !featureFlags.hideSubCategoriesOnCategoryTile"
        class="category-list">
      <li *ngFor="let category of childCategories | slice:0:subCategoriesPreviewFold"
          class="category-list__item">
        <a class="category-list__link"
           [routerLink]="['/categories/' + category.pathedSlug]"
           data-gtm-event-category="Categorytree"
           [attr.data-gtm-event-action]="'Click Category - Name ' + name"
           data-gtm-event-label="CategorytreeTileBadge">
          {{ category.name }}
        </a>
      </li>
      <li *ngIf="childCategories.length > subCategoriesPreviewFold"
          class="category-list__item">
        <a class="category-list__link"
           [routerLink]="['/categories/' + pathedSlugs]"
           data-gtm-event-category="Categorytree"
           [attr.data-gtm-event-action]="'Click Category - Name ' + name"
           data-gtm-event-label="CategorytreeTileBadge"
           i18n="more title for folded subcategories // page: all pages with category tree @@category-tile.component_more-title">
          +{{ childCategories.length - subCategoriesPreviewFold }} more
        </a>
      </li>
    </ul>
  </ng-container>
</p1-lib-ui-elements-image-tile>
